export default __webpack_public_path__ + "static/media/icon-mail-cycle.fe3a355e.svg";